<template>
  <div class="maxMd:w-full md:relative z-[2] md:z-auto top-[70px] md:top-auto ltr:left-0 ltr:md:left-auto"
    id="sub-menu-items" ref="subMenuItems">
    <div :id="customId? customId : 'item' + items.length" class="flex w-full justify-start"
      :class="[needsScroll ? 'custom-scrollbar scroll-smooth overflow-x-auto ' : 'overflow-x-hidden', `gap-${itemsGap}`]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalScrollable",
  props: {
    items: Array,
    itemsGap: {
      type: Number,
      default: 0
    },
    customId: {
      type: String,
      default: 'item'
    }
  },
  data() {
    return {
      needsScroll: false
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  watch: {
    items() {
      this.$nextTick(this.checkOverflow);
    },
  },
  computed: {},
  mounted() {
    this.alignActiveRouteOnMobile()
    // Create a new ResizeObserver instance
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflow();
    });
    this.resizeObserver.observe(this.$refs.subMenuItems);
  },
  methods: {
    /**
     * Function to align options for mobile
     */
    alignActiveRouteOnMobile() {
      const activeRouteIndex = this.items.findIndex(r => r.isActive)
      if (activeRouteIndex) {
        document.getElementById('sub-menu-items').scrollLeft += 160 * activeRouteIndex - 80
      }
    },
    /**
     * Function to check if it needs scroll or not
     */
    checkOverflow() {
      const container = this.$refs.subMenuItems;
      let contentContainer = '';
      if (this.customId) {
         contentContainer = document.getElementById(this.customId)
      } else contentContainer = document.getElementById('item' + this.items.length)
      this.needsScroll = contentContainer.scrollWidth > container?.clientWidth;
    }
  }
};
</script>

<style>
.custom-scrollbar::-webkit-scrollbar {
  height: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #E9EDF4;
  border-radius: 12px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 12px;
  border: 3px solid #2b63e3;
}
</style>
